import React from 'react'
import SaludVisualComponente from '../components/saludvisual/saludvisualcomponente'
const SaludVisual = () => {
  return (
    <>
    <SaludVisualComponente/>
    </>
  )
}

export default SaludVisual